import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;
`;
